import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { faAlignRight } from "@fortawesome/free-solid-svg-icons";
import { text } from "@fortawesome/fontawesome-svg-core";
import Autocomplete from "../../component/autocomplete";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fromDate: "",
      toDate: "",
      setStatus: "",
      submittedDateFrom: "",
      submittedDateTo: "",
      setStatus: "",
      status: "",
      activeStatus: "",
      setBranch: "",
      setPrincipal: "",
      lovPrincipal: [],
      branch: [],
      princid: "",
      lovBranch: [],
      kwitansi: "",
      export: false,
      originOrgid: "",
      customerId: 0,
      customerName: "",
      bupotexist: "",
      expDate: "",
    };
  }

  componentDidMount = () => {
    // let url = "/api/traces/v1/report/reportbranch";
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //   return item.org_id;
    // });

    // let param = {
    //   user_id: this.state.user.user_id,
    //   source: "arman",
    //   org_id: branchGroup,
    // };
    // this.setState({ loading: true });
    // requester.postTraces(url, param, {
    //   success: function (response) {
    //     let { data } = response.data;
    //     data.data.map((item, index) => {
    //       item.formatted_start_date = moment(item.start_date).format(
    //         "DD-MM-YYYY"
    //       );
    //       item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
    //       return item;
    //     });
    //     this.setState({
    //       loading: false,
    //       dataTable: data.data,
    //       baseTable: data.data,
    //     });
    //   }.bind(this),
    //   error: function (e) {
    //     this.setState({ loading: false });
    //   }.bind(this),
    // });
    console.log(JSON.parse(window.localStorage.getItem("is_user")));
    this.getPrincipal();
    this.getBranch();
  };

  onSelectCustomer = (suggestions, index) => {
    let customer_id = 0;
    let customer_name = "";
    this.setState({ customerId: 0, customerName: "" });
    customer_id = suggestions.value ? suggestions.value : 0;
    customer_name = suggestions.text ? suggestions.text : null;
    this.setState({ customerId: customer_id, customerName: customer_name });
    // console.log(customerSave)
  };

  onChangeAutocompleteCust = (q) => {
    this.setState({ customerId: 0, customerName: "" });
    let param = {
      // branch_id: this.state.user.org_id,
      branch_id: this.state.setBranch,
      customer_name: q,
    };
    let container = [];
    this.setState({ customerId: 0, customerName: "" });
    return new Promise((resolve) => {
      requester.postOracle("/api/orafin/v1/participant/customer", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_NAME;
            item.value = item.CUSTOMER_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  getBranch = () => {
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //     return item.org_id
    // })

    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });

    if (this.state.user.origin === "CAB") {
      this.state.originOrgid = this.state.user.org_id;
      this.state.setBranch = this.state.user.org_id;
    }

    // this.setState({ lovBranch: this.state.user.branch });
    console.log(this.state.originOrgid);
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Program No",
          accessor: "program_no",
          filterable: true,
          width: 200,
        },
        {
          Header: "Ref No",
          accessor: "ref_no",
          filterable: true,
          width: 200,
        },

        {
          Header: "Member Type",
          accessor: "member_type",
          filterable: true,
          width: 200,
        },
        {
          Header: "Cabang",
          accessor: "cabang",
          filterable: true,
          width: 200,
        },
        {
          Header: "Program Type",
          accessor: "program_type",
          filterable: true,
          width: 200,
        },
        {
          Header: "Description",
          accessor: "description",
          filterable: true,
          width: 200,
        },
        {
          Header: "Principal",
          accessor: "principal",
          filterable: true,
          width: 200,
        },
        {
          Header: "Start Date",
          accessor: "start_date",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "End Date",
          accessor: "end_date",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "Submitted Date Program",
          accessor: "submitted_date_program",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "Claim Exp Date",
          accessor: "claim_exp_date",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "Participant",
          accessor: "principal",
          filterable: true,
          width: 200,
        },
        {
          Header: "Assignment Status",
          accessor: "status_assign",
          filterable: true,
          width: 200,
        },
        {
          Header: "Assignment Date",
          accessor: "assign_date",
          filterable: true,
          width: 200,
        },
        {
          Header: "Cabang Assign",
          accessor: "cabang_assign",
          filterable: true,
          width: 200,
        },
        {
          Header: "Customer Name",
          accessor: "customer_name",
          filterable: true,
          width: 200,
        },
        {
          Header: "SKP Number",
          accessor: "skp_number",
          filterable: true,
          width: 200,
        },
        {
          Header: "Claim",
          accessor: "claim",
          filterable: true,
          width: 200,
        },
        {
          Header: "Claim Number",
          accessor: "claim_number",
          filterable: true,
          width: 200,
        },
        {
          Header: "Claim Status",
          accessor: "claim_status",
          filterable: true,
          width: 200,
        },

        //==============================================================
        //==============================================================
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/assign/summary/" + row.program_customer_id);
  };

  handleSearch = () => {
    let url = "/api/traces/v1/report/reportunassign";
    let param = {
      export: this.state.export,
      org_id: this.state.setBranch,
      source: "arman",
      status: this.state.setStatus,
      active_status: this.state.activeStatus,
      principal: this.state.setPrincipal,
      customerid: this.state.customerId,
      ebupot_exist: this.state.bupotexist,
      from_date:
        this.state.fromDate != ""
          ? moment(new Date(this.state.fromDate)).format("YYYY-MM-DD")
          : "",
      to_date:
        this.state.toDate != ""
          ? moment(new Date(this.state.toDate)).format("YYYY-MM-DD")
          : "",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
      expdate:
        this.state.expDate != ""
          ? moment(new Date(this.state.expDate)).format("YYYY-MM-DD")
          : "",
    };

    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.data.map((item, index) => {
          item.formatted_start_date = moment(new Date(item.start_date)).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(new Date(item.end_date)).format(
            "DD-MM-YYYY"
          );
          return item;
        });
        if (this.state.export) {
          window.open(data.fullurl, "_blank");
        }
        this.setState({
          loading: false,
          dataTable: data.data,
          baseTable: data.data,
          export: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
    // this.getBranch();
  };

  handleChangeStatus = (e) => {
    this.state.setStatus = e.target.value;
  };

  handleChangeBupot = (e) => {
    this.state.bupotexist = e.target.value;
  };

  handleChangeBranch = (e) => {
    this.state.setBranch = e.target.value;
  };

  handleChangePrincipal = (e) => {
    this.state.setPrincipal = e.target.value;
  };

  handleChangeValue = (event) => {
    let value = event.target.value;
    let valname = event.target.name;

    // this.setState({ activeflag: value })

    if (valname === "org_id") {
      this.setState({ princid: value });
    }

    window.setTimeout(() => {
      console.log(valname);
    }, 100);
  };

  handleFind = () => {
    // let value = e.target.value
    let url = "/api/traces/v1/report/reportunassign";
    let branchGroup = this.state.user.branch.map((item, index) => {
      return item.org_id;
    });

    let param = {
      // "org_id": this.state.user.org_id,
      // "status": this.state.setStatus,
      // "from_date": moment(this.state.fromDate).format('YYYY-MM-DD'),
      // "to_date":moment(this.state.toDate).format('YYYY-MM-DD'),
      // "princlov" : this.state.princid

      user_id: this.state.user.user_id,
      source: "arman",
      org_id: branchGroup,
      from_date: moment(this.state.fromDate).format("YYYY-MM-DD"),
      to_date: moment(this.state.toDate).format("YYYY-MM-DD"),
    };

    this.setState({ loading: true, search: "" });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };


  handlefromDate = (date) => {
    this.setState({ fromDate: date });
  };

  handletoDate = (date) => {
    this.setState({ toDate: date });
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleexpDate = (date) => {
    this.setState({ expDate: date });
  };

  handleExport = () => {
    const fileName = `report-assignment-${new Date().getTime()}.xlsx`
    const format = 'DD MMM YYYY';
    const maping = this.state.dataTable && this.state.dataTable.length ? this.state.dataTable.map((value) => {
      return {
        "Program No" : value.program_no,
        "Ref No" : value.ref_no,
        "Member Type" : value.member_type,
        "Cabang" : value.cabang,
        "Program Type" : value.program_type,
        "Description" : value.description,
        "Principal" : value.principal,
        "START DATE": value.start_date && moment.utc(value.start_date, 'YYYY-MM-DD HH:mm:ss').format(format) !== 'Invalid date' ? new Date(moment(value.start_date).utc().format("DD MMM YYYY")) : '-',
        "END DATE": value.end_date && moment.utc(value.end_date, 'YYYY-MM-DD HH:mm:ss').format(format) !== 'Invalid date' ? new Date(moment(value.end_date).utc().format("DD MMM YYYY")) : '-',
        "Submitted Date Program" : value.submitted_date_program && moment.utc(value.submitted_date_program, 'YYYY-MM-DD HH:mm:ss').format(format) !== 'Invalid date' ? new Date(moment(value.submitted_date_program).utc().format("DD MMM YYYY")) : '-',
        "Claim Exp Date" : value.claim_exp_date && moment.utc(value.claim_exp_date, 'YYYY-MM-DD HH:mm:ss').format(format) !== 'Invalid date' ? new Date(moment(value.claim_exp_date).utc().format("DD MMM YYYY")) : '-',
        "Participant" : value.principal,
        "Assignment Status" : value.status_assign,
        "Assignment Date" : value.assign_date,
        "Cabang Assign" : value.cabang_assign,
        "Customer Name" : value.customer_name,
        "SKP Number" : value.skp_number,
        "Claim" : value.claim,
        "Claim Number" : value.claim_number,
        "Claim Status" : value.claim_status,
      }
    }) : []

    requester.downloadXlsxDateFormat(maping, fileName)

    // this.setState({ export: true });
    // let app = this;
    // window.setTimeout(() => {
    //   app.handleSearch();
    // }, 200);
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row mt-3"></div>

                            <div className="row">
                              <div className="col-md-2 mt-1">
                                Prg Submitted Date From{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateFrom}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateFrom}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Prg Submitted Date To{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateTo}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateTo}
                                />
                              </div>
                            </div>
                            {/* <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Approved Date From{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.fromDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handlefromDate}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Approved Date To{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.toDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handletoDate}
                                />
                              </div>
                            </div> */}
                            <div className="row mt-3">
                              {/* <div className="col-md-2 mt-1">
                                Expired After{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.expDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleexpDate}
                                />
                              </div> */}
                              <div className="col-md-2">Assignment Status</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeStatus.bind(this)}
                                >
                                  <option value="">Unassigned</option>
                                  <option value="ASSIGNED">Assigned</option>
                                </select>
                              </div>
                              {/* <div className="col-md-2">Active Status</div>
                                                            <div className="col-md-3">
                                                                <select className="form-control" onChange={ this.handleChangeStatusActive.bind(this) }>
                                                                    <option value="">- Select Status -</option>
                                                                    <option value="Y">Active</option>
                                                                    <option value="N">Inactive</option>
                                                                </select>
                                                            </div> */}
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">Principal </div>
                              <div className="col-lg-3">
                                <select
                                  className="form-control"
                                  name="org_id"
                                  onChange={this.handleChangePrincipal.bind(
                                    this
                                  )}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovPrincipal.map(
                                    (item, index) => (
                                      <option key={index} value={item.org_id}>
                                        {item.org_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">Branch</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="branchId"
                                  onChange={this.handleChangeBranch.bind(this)}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovBranch.map((item, index) => (
                                    <option
                                      value={item.org_id}
                                      key={index}
                                      selected={
                                        this.state.originOrgid == item.org_id
                                          ? true
                                          : false
                                      }
                                    >
                                      {item.org_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {/* <div className="row mt-3">
                              <div className="col-md-2">E-Bupot</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeBupot.bind(this)}
                                >
                                  <option value="">All</option>
                                  <option value="Y">Yes</option>
                                  <option value="N">No</option>
                                </select>
                              </div>
                              <div className="col-md-2">Customer</div>
                              <div className="col-md-3">
                                <Autocomplete
                                  id="customer_auto"
                                  onchange={this.onChangeAutocompleteCust.bind(
                                    this
                                  )}
                                  onselect={this.onSelectCustomer.bind(this)}
                                />
                              </div>
                            </div> */}
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              <div className="col-md-3">
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.handleExport.bind(this)}
                                >
                                  <i class="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
